// Light / dark / system theme. The choice is a per-browser convenience (localStorage); "system" follows the OS.
export type ThemeChoice = "system" | "light" | "dark";
const KEY = "aisdr-theme";

export function getTheme(): ThemeChoice {
  try {
    return (localStorage.getItem(KEY) as ThemeChoice) || "system";
  } catch {
    return "system";
  }
}

export function applyTheme(choice: ThemeChoice = getTheme()) {
  const dark = choice === "dark" || (choice === "system" && window.matchMedia?.("(prefers-color-scheme: dark)").matches);
  document.documentElement.classList.toggle("dark", !!dark);
}

export function setTheme(choice: ThemeChoice) {
  try {
    localStorage.setItem(KEY, choice);
  } catch {
    /* private mode: just apply */
  }
  applyTheme(choice);
}

export function watchSystemTheme() {
  window.matchMedia?.("(prefers-color-scheme: dark)").addEventListener?.("change", () => applyTheme());
}
